<color-sketch [(color)]="color" [disableAlpha]="true" [presetColors]="PREDEFINED_COLORS" style="width:200px ;"
(onChangeComplete)="onColorChanged($event)"></color-sketch>
<button mat-flat-button color="primary" [mat-dialog-close]="{color:color}">{{ 'Confirm' | i18next}}</button>
